import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import {
  CmpButton,
  CmpDatePicker,
  CmpSelectBox,
  CmpTextFieldEnter,
} from "../../Component/Common/ToolBox/ToolBox";
import { Box, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import {
  EasyBinTransfer_Src,
  Src_Set,
  Summary_Set,
} from "./SliceEasyBinTransfer";
import { useDispatch } from "react-redux";
import moment from "moment";
import EasyBinTransferSummaryCard from "./component/EasyBinTransferSummaryCard";
import EasyBinTransfer_Breadcrumbs from "./EasyBinTransfer_Breadcrumbs";
import { GetSummary, statusData, typeData } from "./EasyBinTransferAction";
import { RoEasyBinTransfer } from "../../Redux/roStore";

import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
export default function EasyBinTransferSummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const vRdxLocation = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxSummary = useSelector(
    (state) => state.SliceEasyBinTransfer.value.Summary
  );

  const [summaryData, setSummaryData] = useState([]);
  const onChangeInput = (e) => {
    dispatch(
      Summary_Set({
        ...vRdxSummary,
        [e.target.name]: e.target.value,
      })
    );
  };
  const fRouting = (type = vRdxSummary.typeVal) => {
    if (type == "BinTransfer") {
      navigate("/EasyBinTransfer");
    } else if (type == "ItemTransfer") {
      navigate("/EasyItemTransfer");
    } else if (type == "CardIDTransfer") {
      navigate("/EasyCardIdTransfer");
    }
  };

  const onPressLoad = async (
    v_Loc = vRdxSummary.loc,
    v_Date1 = vRdxSummary.dateFrom,
    v_Date2 = vRdxSummary.dateTo,
    v_Status = vRdxSummary.statusVal,
    v_Type = vRdxSummary.typeVal
  ) => {
    await GetSummary(setSummaryData, v_Loc, v_Date1, v_Date2, v_Status, v_Type);
  };

  // useEffect(() => {
  //   setEasyBinSummaryData(vRdxSummary);
  // }, [vRdxSummary]);

  useEffect(() => {
    dispatch(EasyBinTransfer_Src());
    dispatch(
      Summary_Set({
        ...vRdxSummary,
        loc: vRdxLocation[0]?.UID,
        dateFrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 10
        ),
        dateTo: new Date(),
        statusVal: typeData[0].id,
        typeVal: statusData[0].id,
      })
    );
    onPressLoad(
      vRdxLocation[0]?.UID,
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - 10
      ),
      new Date(),
      typeData[0].id,
      statusData[0].id
    );
  }, []);

  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end
  return (
    <div className="container-fluid my-3">
      {/* <div className="Breadcrumbs d-flex my-3">
        <EasyBinTransfer_Breadcrumbs />
      </div> */}
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <EasyBinTransfer_Breadcrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferData">
          <div className="gridStyle">
            <Grid container spacing={1} alignItems={"center"} sx={{display:'none'}}>
              <Grid item md={2} xs={6}>
                <CmpSelectBox
                  xLabelText="Location"
                  xValue={
                    vRdxSummary.loc == ""
                      ? vRdxLocation[0]?.UID
                      : vRdxSummary.loc
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"loc"}
                  xData={vRdxLocation}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item md={2} xs={6}>
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={vRdxSummary.dateFrom}
                  xOnChange={(newValue) => {
                    dispatch(
                      Summary_Set({
                        ...vRdxSummary,
                        dateFrom: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item md={2} xs={6}>
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={vRdxSummary.dateTo}
                  xOnChange={(newValue) => {
                    dispatch(
                      Summary_Set({
                        ...vRdxSummary,
                        dateTo: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item md={1.5} xs={6}>
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={
                    vRdxSummary.statusVal == ""
                      ? statusData[0].id
                      : vRdxSummary.statusVal
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"statusVal"}
                  xData={statusData}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <CmpSelectBox
                  xLabelText="Type"
                  xValue={
                    vRdxSummary.typeVal == ""
                      ? statusData[0].id
                      : vRdxSummary.typeVal
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"typeVal"}
                  xData={typeData}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                md={1}
                xs={6}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={() => {
                    onPressLoad(
                      vRdxSummary.loc,
                      vRdxSummary.dateFrom,
                      vRdxSummary.dateTo,
                      vRdxSummary.statusVal,
                      vRdxSummary.typeVal
                    );
                  }}
                />
              </Grid>
              <Grid
                item
                md={1}
                xs={6}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="New"
                  xOnClick={() => {
                    let { Summary } = RoEasyBinTransfer();
                    dispatch(
                      Src_Set({
                        DocTypCode: "",
                        DocTypName: "",
                        DocNo: 0,
                        Date: new Date(),
                        LocCode: vRdxSummary.loc,
                        LocName: "",
                        Type: Summary.typeVal,
                        Status: "Enter",
                        BinCodeFrom: "",
                        BinNameFrom: "",
                        ItemCode: "",
                        ItemName: "",
                        CardId: 0,
                        Qty: 0,
                        UnitCode: "",
                        UnitName: "",
                        BaseQty: 0,
                        BinCodeTo: "",
                        BinNameTo: "",
                        PackQty: 0,
                      })
                    );
                    fRouting();
                  }}
                />
              </Grid>
            </Grid>
            {/* <Grid container spacing={0} className='my-1' justifyContent={"end"}>
              <Grid item md={1} xs={6} className="bintransfet-data-load-btn">
                <CmpButton
                  xbtnName="Load"
                  xOnClick={() => {
                    onPressLoad(
                      vRdxSummary.loc,
                      vRdxSummary.dateFrom,
                      vRdxSummary.dateTo,
                      vRdxSummary.statusVal,
                      vRdxSummary.typeVal
                    );
                  }}
                />
              </Grid>
              <Grid item md={1} xs={6} className="bintransfet-data-load-btn">
                <CmpButton
                  xbtnName="New"
                  xOnClick={() => {
                    dispatch(
                      Src_Set({
                        DocTypCode: "",
                        DocTypName: "",
                        DocNo: 0,
                        Date: new Date(),
                        LocCode: vRdxSummary.loc,
                        LocName: "",
                        Type: "",
                        Status: "Enter",
                        BinCodeFrom: "",
                        BinNameFrom: "",
                        ItemCode: "",
                        ItemName: "",
                        CardId: 0,
                        Qty: 0,
                        UnitCode: "",
                        UnitName: "",
                        BaseQty: 0,
                        BinCodeTo: "",
                        BinNameTo: "",
                      })
                    );
                    fRouting()
                  }}
                />
              </Grid>
            </Grid> */}
          </div>

          <Box>
            <Grid
              container
              spacing={{ xs: 0, md: 3 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <EasyBinTransferSummaryCard
                  data={summaryData}
                  onClick={(item) => {
                    console.log(item);
                    dispatch(Src_Set({ ...item, PackQty: 0 }));
                    fRouting(item.Type);
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <GCSummaryModal
            xOpen={showModal}
            fCloseModal={() => {
              setShowModal(false);
            }}
            xTitle="Filter"
            component={<>
             <Grid container spacing={1} alignItems={"center"}  >
              <Grid item  xs={6}>
                <CmpSelectBox
                  xLabelText="Location"
                  xValue={
                    vRdxSummary.loc == ""
                      ? vRdxLocation[0]?.UID
                      : vRdxSummary.loc
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"loc"}
                  xData={vRdxLocation}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item   xs={6}>
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={vRdxSummary.dateFrom}
                  xOnChange={(newValue) => {
                    dispatch(
                      Summary_Set({
                        ...vRdxSummary,
                        dateFrom: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item  xs={6}>
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={vRdxSummary.dateTo}
                  xOnChange={(newValue) => {
                    dispatch(
                      Summary_Set({
                        ...vRdxSummary,
                        dateTo: newValue.$d,
                      })
                    );
                  }}
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item  xs={6}>
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={
                    vRdxSummary.statusVal == ""
                      ? statusData[0].id
                      : vRdxSummary.statusVal
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"statusVal"}
                  xData={statusData}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item  xs={12}>
                <CmpSelectBox
                  xLabelText="Type"
                  xValue={
                    vRdxSummary.typeVal == ""
                      ? statusData[0].id
                      : vRdxSummary.typeVal
                  }
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"typeVal"}
                  xData={typeData}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid
                item
                 
                xs={6}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={() => {
                    onPressLoad(
                      vRdxSummary.loc,
                      vRdxSummary.dateFrom,
                      vRdxSummary.dateTo,
                      vRdxSummary.statusVal,
                      vRdxSummary.typeVal
                    );
                    setShowModal(false);
                  }}
                />
              </Grid>
              <Grid
                item
                
                xs={6}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="New"
                  xOnClick={() => {
                    let { Summary } = RoEasyBinTransfer();
                    dispatch(
                      Src_Set({
                        DocTypCode: "",
                        DocTypName: "",
                        DocNo: 0,
                        Date: new Date(),
                        LocCode: vRdxSummary.loc,
                        LocName: "",
                        Type: Summary.typeVal,
                        Status: "Enter",
                        BinCodeFrom: "",
                        BinNameFrom: "",
                        ItemCode: "",
                        ItemName: "",
                        CardId: 0,
                        Qty: 0,
                        UnitCode: "",
                        UnitName: "",
                        BaseQty: 0,
                        BinCodeTo: "",
                        BinNameTo: "",
                        PackQty: 0,
                      })
                    );
                    fRouting();
                    setShowModal(false);
                  }}
                />
              </Grid>
            </Grid>
            </>}
          />
        </div>
      </div>
    </div>
  );
}
